/* eslint-env browser */
import moment from 'moment';
import {
  setCookie,
  getCookie,
  addToSessionStorage,
  getFromSessionStorage,
} from '@aarhus-university/au-lib-react-components/src/lib/helpers';
import {
  GET_VACANCIES,
  GET_AREAS,
  GET_HOURS,
  GET_LOCATIONS,
  SET_FILTER,
} from '../actions/const';

const initialState = {
  areas: [],
  locations: [],
  hours: [],
  errors: [],
  vacancies: [],
  filtered: [],
  title: '',
  mode: '',
  phdLink: '',
  totalAmount: 0,
  loaded: false,
  sessionValid: false,
};

const parseZip = (zipString) => {
  const split = zipString.split('-');
  return {
    lower: parseInt(split[0], 10),
    upper: parseInt(split[split.length - 1], 10),
  };
};

const cookieName = 'au-vacancies-last-visit';

export default (state = initialState, action) => {
  const nextState = { ...state };

  switch (action.type) {
    case GET_AREAS: {
      nextState.areas = action.payload;
      return nextState;
    }
    case GET_HOURS: {
      nextState.hours = action.payload;
      return nextState;
    }
    case GET_LOCATIONS: {
      nextState.locations = action.payload;
      return nextState;
    }
    case GET_VACANCIES: {
      const cookieValue = getCookie(cookieName);
      let lastVisit = new Date();
      if (cookieValue) {
        lastVisit = new Date(parseInt(cookieValue, 10));
      }
      const { data } = action.payload;
      const sessionFiltered = getFromSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-filtered`);
      const sessionAmount = getFromSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-amount`);
      nextState.vacancies = data.vacancies;
      nextState.sessionValid = sessionAmount === nextState.vacancies.length;

      const newVacancies = [];
      const oldVacancies = [];
      nextState.vacancies.sort((a, b) => (a.deadline > b.deadline ? 1 : -1)).forEach((v) => {
        const vacancy = v;
        // Lille bitte hack...
        if (vacancy.mode === 'dvip' || vacancy.mode === 'ing') {
          vacancy.mode = 'vip';
        }
        if (vacancy.mode === 'dtap') {
          vacancy.mode = 'tap';
        }
        if (nextState.sessionValid) {
          const foundInSession = sessionFiltered.find((x) => x.id === vacancy.id);
          if (foundInSession) {
            vacancy.new = foundInSession.new; // Wut
            nextState.sessionValid = JSON.stringify(foundInSession) === JSON.stringify(vacancy);
          }
        }
        if (moment(v.registered) > lastVisit) {
          vacancy.new = true;
          newVacancies.push(vacancy);
        } else {
          vacancy.new = false;
          oldVacancies.push(vacancy);
        }
      });

      nextState.vacancies = [...newVacancies, ...oldVacancies];

      nextState.filtered = (
        sessionFiltered && nextState.sessionValid ? sessionFiltered : nextState.vacancies
      );
      nextState.title = data.title;
      nextState.phdLink = data.phdLink;
      nextState.mode = data.mode;
      nextState.totalAmount = data.vacancies.length;
      nextState.loaded = true;

      setCookie(cookieName, moment().format('x'), 365, ';path=/');
      if (!nextState.sessionValid) {
        addToSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-filtered`, nextState.vacancies);
        addToSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-amount`, nextState.vacancies.length);
      }
      console.log('Valid session storage:', nextState.sessionValid);
      return nextState;
    }
    case SET_FILTER: {
      const filter = action.payload;
      let newFiltered = nextState.vacancies;

      if (filter.mode !== '') {
        newFiltered = newFiltered.filter(
          (x) => x.mode === filter.mode,
        );
      }

      if (filter.hours != null) {
        if (filter.hours.value === 'parttime') {
          newFiltered = newFiltered.filter(
            (x) => x.hours < 37,
          );
        } else if (filter.hours.value === 'fulltime') {
          newFiltered = newFiltered.filter(
            (x) => x.hours === 37,
          );
        }
      }

      if (filter.area !== 0) {
        newFiltered = newFiltered.filter(
          (x) => x.area === filter.area.value,
        );
      }

      if (filter.location != null) {
        const range = parseZip(filter.location.value);
        newFiltered = newFiltered.filter(
          (x) => x.location.zip >= range.lower && x.location.zip <= range.upper,
        );
      }

      addToSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-filter`, filter);
      addToSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-filtered`, newFiltered);
      addToSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-amount`, nextState.vacancies.length);
      nextState.filtered = newFiltered;
      return nextState;
    }

    default: {
      return state;
    }
  }
};
